var map = {
	"./c1.jpeg": 6395,
	"./c2.jpeg": 5086,
	"./c3.jpeg": 6997,
	"./c4.jpeg": 2960,
	"./c7.jpeg": 1249,
	"./z4.jpg": 7024,
	"./z5.jpg": 5597,
	"./z6.jpg": 9666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 365;